import { MDSButton, MDSIcon } from '@marqvision/mds-v2';
import { FilterChipProps } from './@types';
import { getSelectedTags } from './@utils';

export const FilterChip = (props: FilterChipProps) => {
  const { type, color = 'bluegray', label, selected, startIcon: _startIcon, size = 'medium', ...restProps } = props;

  const isSelected = Boolean(Array.isArray(selected) ? selected.length : selected);
  const chipVariant = isSelected ? 'fill' : 'tint';
  const startIcon = type === 'toggle' && isSelected ? <MDSIcon.Check variant="outline" /> : _startIcon;
  const endIcon = type !== 'toggle' ? <MDSIcon.ArrowDown variant="outline" /> : undefined;
  const tags = getSelectedTags(props);

  return (
    <MDSButton
      variant={chipVariant}
      size={size}
      color={color}
      startIcon={startIcon}
      endIcon={endIcon}
      tags={tags || undefined}
      {...restProps}
    >
      {label}
    </MDSButton>
  );
};

/*
* 예시 코드
*
* - Toggle
  <FilterChip
    type="toggle"
    color="bluegray"
    label="Filter label"
    selected={isSelected}
    onClick={() => setIsSelected(isSelected ? null : true)}
  />
*
* - Other
  <>
    <FilterChip
      type="other"
      color="bluegray"
      label="Filter label"
      selected={selectedLabel}  // tag 에 보여질 text
      onClick={(e) => setAnchorEl(e.currentTarget as HTMLElement)}
    />
    {anchorEl && (
      <TimecodeRangePicker
        anchorEl={anchorEl}
        value={{ min: filter?.min || null, max: filter?.max || null }}
        onApply={handleApply}
        onClose={() => setAnchorEl(null)}
      />
    )}
  </>
* */
